let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aog6z")).then(() => parcelRequire('he0oB'));